// TODO: replace references to this file with the '@mui/toolpad-utils/hooks/useBoolean'
export { default } from '@mui/toolpad-utils/hooks/useBoolean';
